import React from 'react';
import { PaymentType } from './PaymentForm';
import { CreditCardIcon, SplitIcon, CreditCardIcon as SavedCardIcon, LockIcon, StoreIcon, LinkIcon } from 'lucide-react';
import { InfoTooltip } from './InfoTooltip';
interface PaymentTypeSelectorProps {
  activeType: PaymentType;
  onChange: (type: PaymentType) => void;
}
export function PaymentTypeSelector({
  activeType,
  onChange
}: PaymentTypeSelectorProps) {
  return <div className="flex" data-id="element-924">
      <TabButton isActive={activeType === 'standard'} onClick={() => onChange('standard')} icon={<CreditCardIcon size={18} data-id="element-926" />} label="Single payment" tooltip="Create a single payment for your customer" data-id="element-925" />
      <TabButton isActive={activeType === 'fixed-links'} onClick={() => onChange('fixed-links')} icon={<LinkIcon size={18} data-id="element-928" />} label="Fixed links" tooltip="Create permanent links with fixed amounts and custom fields" data-id="element-927" />
      <TabButton isActive={activeType === 'installment'} onClick={() => onChange('installment')} icon={<SplitIcon size={18} data-id="element-930" />} label="Split payment" tooltip="Divide payments by schedule or between multiple people" data-id="element-929" />
      <TabButton isActive={activeType === 'card-on-file'} onClick={() => onChange('card-on-file')} icon={<SavedCardIcon size={18} data-id="element-932" />} label="Saved card" tooltip="Charge a customer's previously saved payment method" data-id="element-931" />
      <TabButton isActive={activeType === 'preauth'} onClick={() => onChange('preauth')} icon={<LockIcon size={18} data-id="element-934" />} label="Security hold" tooltip="Place a temporary hold on a customer's card without charging" data-id="element-933" />
      <TabButton isActive={activeType === 'shop-products'} onClick={() => onChange('shop-products')} icon={<StoreIcon size={18} data-id="element-936" />} label="Shop products" tooltip="Select products from your store to include in this payment" data-id="element-935" />
    </div>;
}
interface TabButtonProps {
  isActive: boolean;
  onClick: () => void;
  icon: React.ReactNode;
  label: string;
  tooltip: string;
}
function TabButton({
  isActive,
  onClick,
  icon,
  label,
  tooltip
}: TabButtonProps) {
  return <button onClick={onClick} className={`flex items-center px-4 py-3 text-sm font-medium transition-colors border-b-2 -mb-px ${isActive ? 'text-blue-600 border-blue-600' : 'text-gray-600 border-transparent hover:text-gray-800 hover:border-gray-300'}`} data-id="element-937">
      <span className="mr-2" data-id="element-938">{icon}</span>
      <span data-id="element-939">{label}</span>
      <InfoTooltip content={tooltip} data-id="element-940" />
    </button>;
}